import { CaseProduct } from '../../../form-application/mortgage-application/models/case-product.model';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { FormApplication } from '../../shared/models/form-application.model';
import { KfiApplicant } from './kfi-applicant.model';

export class Kfi extends FormApplication {
  public KfiNumber: number;
  public CaseNumber?: number;
  public LoanTypeCode: string;
  public DateModified?: Date;
  public DateSubmitted?: Date;
  public FeeID?: number;
  public Guid: string;
  public RemortgageEstimatedPropertyValue?: number;
  public Pdf: Array<number>;
  public PdfGenerated?: boolean;
  public PurchasePropertyPrice?: number;
  public StatusCode: string;
  public PurchasingAtConcessionaryPriceCode: string;
  public TrueMarketPrice?: number;
  public ProductSelectionTypeCode: string;
  public ApplyHelpToBuySchemeCode: string;
  public SubmittedStaffID?: number;
  public SubmittedAgentID?: number;
  public Ltv?: number;
  public IsAuditable?: boolean;
  public LastModifiedAgentID?: number;
  public SubmittedBranchUserID?: number;
  public LastModifiedBranchUserID?: number;
  public SubmittedDirectCustomerID?: number;
  public LastModifiedDirectCustomerID?: number;
  public IsNewlyGenerated?: boolean;
  public DateCreated?: Date;
  public AcceptedByDirectCustomerID?: number;
  public AcceptedDate?: Date;
  public LastModifiedStaffID?: number;
  public IsForAdvice: boolean;
  public AllowsExpiredProduct: boolean;
  public KfiApplicants: Array<KfiApplicant>;
  public CaseProducts: Array<CaseProduct>;
  public IllustrationStatusCode: string;
  public WasIllustrationReplaced?: boolean;
  public IsOverrideIllustrationRequired?: boolean;
  public PropertyEPCRatingCode: string;

  deserialize(input: any): this {
    super.deserialize(input);
    this.deserializeCaseProducts(input);
    if (input.KfiApplicants) {
      this.KfiApplicants = input.KfiApplicants.map((method) => new KfiApplicant().deserialize(method));
    }

    this.IsKfi = true;

    return this;
  }

  private deserializeCaseProducts(input: any): void {
    if (input.CaseProducts && input.CaseProducts.length > 0) {
      this.CaseProducts = input.CaseProducts.map((method) => new CaseProduct().deserialize(method));
      input.CaseProducts.length > 1 ? this.configurePartAndPart() : this.configureSingleProduct();
    } else {
      this.configureNoProduct();
    }
  }

  private configurePartAndPart(): void {
    this.RepaymentTypeCodeCache = ReferenceDataOptionLists.RepaymentTypePartAndPart;

    if (this.CaseProducts[1].LoanAmount !== null && this.CaseProducts[1].LoanAmount !== undefined) {
      this.LoanAmountCache = this.CaseProducts[0].LoanAmount + this.CaseProducts[1].LoanAmount;
    }

    const product = this.CaseProducts[0].Product;
    if (product) {
      delete (product as any).$id;
      this.CaseProducts[1].Product = product;
    }
  }

  private configureSingleProduct(): void {
    this.LoanAmountCache = this.CaseProducts[0].LoanAmount;
    this.RepaymentTypeCodeCache = this.CaseProducts[0].RepaymentTypeCode;
  }

  private configureNoProduct(): void {
    this.CaseProducts = new Array<CaseProduct>();
    const caseProduct = new CaseProduct();
    caseProduct.ProductOrder = 0;
    this.CaseProducts.push(caseProduct);
  }
}
